/** Paleta inspirada en el media kit impreso Legalmente en Familia (verde bosque + oro). */
export const light = {
  alternate: {
    main: '#f4f6f4',
    dark: '#e8ebe8',
  },
  cardShadow: 'rgba(27, 51, 38, 0.14)',
  mode: 'light',
  primary: {
    main: '#1B3326',
    light: '#2d4d3d',
    dark: '#122219',
    contrastText: '#fff',
  },
  secondary: {
    light: '#dfc78a',
    main: '#C4A45D',
    dark: '#a98b42',
    contrastText: 'rgba(0, 0, 0, 0.87)',
  },
  text: {
    primary: '#1a241f',
    secondary: '#4a554e',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    paper: '#fff',
    default: '#fff',
    level2: '#f5f7f5',
    level1: '#fff',
  },
};

export const dark = {
  alternate: {
    main: '#15251e',
    dark: '#0f1a15',
  },
  cardShadow: 'rgba(0, 0, 0, 0.2)',
  common: {
    black: '#000',
    white: '#fff',
  },
  mode: 'dark',
  primary: {
    main: '#2d4d3d',
    light: '#3d5f4d',
    dark: '#1B3326',
    contrastText: '#fff',
  },
  secondary: {
    light: '#dfc78a',
    main: '#C4A45D',
    dark: '#a98b42',
    contrastText: 'rgba(0, 0, 0, 0.87)',
  },
  text: {
    primary: '#f0f2f0',
    secondary: '#d4dcd7',
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: '#1B3326',
    default: '#15251e',
    level2: '#1f2e26',
    level1: '#24352c',
  },
};
